import { ReactNode } from 'react';
import { DashboardSection } from '@g17eco/molecules/dashboard';

interface Props {
  title: string;
  count: number;
  children: ReactNode;
  emptyMessage?: string;
}

export const IntegrationList = ({ title, count, children, emptyMessage }: Props) => {
  return (
    <>
      <div className='text-uppercase text-ThemeTextLight text-sm mb-2'>
        {title} ({count})
      </div>
      {count ? (
        <div className='row g-3 mb-4'>{children}</div>
      ) : (
        <DashboardSection className='text-center text-ThemeTextMedium mb-4'>
          {emptyMessage ?? `There are no ${title.toLowerCase()} to display.`}
        </DashboardSection>
      )}
    </>
  );
};
